import { useState } from "react";
import { ClipboardList, LogIn, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const UserMenu = ({ onAdminOpen }) => {
  const { user, login, logout } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user)
    return (
      <button
        type="button"
        data-testid="login-button"
        onClick={login}
        className="flex items-center gap-2 rounded-full border border-purple-400/40 px-4 py-2 font-grotesk text-xs font-bold uppercase tracking-[0.12em] text-purple-100 transition-colors duration-200 hover:border-amber-300 hover:text-amber-300"
      >
        <LogIn className="h-3.5 w-3.5" /> Entrar
      </button>
    );

  return (
    <div className="relative">
      <button
        type="button"
        data-testid="user-menu-button"
        onClick={() => setOpen((o) => !o)}
        aria-label="Minha conta"
        className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full border border-amber-400/50 bg-white/10 font-syne text-sm font-extrabold text-amber-300"
      >
        {user.picture ? (
          <img src={user.picture} alt={user.name} className="h-full w-full object-cover" />
        ) : (
          (user.name || "?")[0].toUpperCase()
        )}
      </button>
      {open && (
        <div
          data-testid="user-menu-dropdown"
          className="absolute right-0 top-12 z-50 w-60 rounded-2xl border border-purple-500/30 bg-[#2D0B5A] p-4 shadow-2xl"
        >
          <p data-testid="user-menu-name" className="truncate text-sm font-bold text-white">
            {user.name}
          </p>
          <p className="truncate text-xs text-purple-300/60">{user.email}</p>
          {user.is_admin && (
            <button
              type="button"
              data-testid="admin-open-button"
              onClick={() => {
                setOpen(false);
                onAdminOpen();
              }}
              className="mt-3 flex w-full items-center gap-2 rounded-xl bg-amber-400 px-4 py-2.5 text-xs font-bold text-[#1E053B] transition-transform duration-200 hover:scale-[1.02]"
            >
              <ClipboardList className="h-4 w-4" /> Pedidos recebidos
            </button>
          )}
          <button
            type="button"
            data-testid="logout-button"
            onClick={() => {
              setOpen(false);
              logout();
            }}
            className="mt-2 flex w-full items-center gap-2 rounded-xl border border-purple-500/30 px-4 py-2.5 text-xs font-bold text-purple-100 transition-colors hover:border-red-400 hover:text-red-400"
          >
            <LogOut className="h-4 w-4" /> Sair
          </button>
        </div>
      )}
    </div>
  );
};
